<div class="page-container">
    <mat-sidenav-container>
        <div id="account-page">
            <div id="page-header">
                <h1>Accounts</h1>
                <button mat-raised-button class="r1-btn-black" [disabled]="true">+ Add Account</button>
            </div>

            <mat-divider id="top-line" />

            <div id="accounts-table">
                <r1-accounts-table (viewAccount)="toggleViewAccountInfo($event)" />
            </div>
        </div>

        @if (sidenavOpen) {
            <mat-sidenav [opened]="sidenavOpen" mode="side" position="end">
                @if (editingSelectedAccount) {
                    <button mat-raised-button (click)="toggleEditAccount()" class="toggle-edit">Cancel</button>
                    <r1-edit-account [account]="selectedAccount" (patchAccountValue)="accountPatched($event)" />
                } @else {
                    <button mat-raised-button (click)="toggleEditAccount()" class="toggle-edit">Edit</button>
                    <r1-view-account [account]="selectedAccount" />
                }
                <button mat-raised-button (click)="closeSidenav()" id="close-sidenav">X</button>
            </mat-sidenav>
        }
    </mat-sidenav-container>
</div>
